import { ConfiguratorHandlerContext } from "helpers/context/Configurator/ConfiguratorContext";
import React from "react";

export default function useConfiguratorHandler() {

    return React.useContext(ConfiguratorHandlerContext)!;

};
